import Balancer from "react-wrap-balancer"

import { Button } from "@productlane/ui"
import {
	CONNECT_MCP_DESCRIPTION,
	CONNECT_MCP_TITLE,
	ConnectMcpContent,
} from "@productlane/ui/src/components/connect-mcp-content"

import { analytics } from "@/lib/analytics"

export function ConnectMcpSlide({ nextSlide }: { nextSlide: () => void }) {
	return (
		<div className="flex flex-col items-center text-center">
			<div className="mb-1 text-3xl font-bold tracking-tight">
				{CONNECT_MCP_TITLE}
			</div>
			<Balancer className="tracking-tight text-secondary">
				{CONNECT_MCP_DESCRIPTION}
			</Balancer>

			<div className="mt-8 w-full max-w-lg text-left">
				<ConnectMcpContent />
			</div>

			<Button size="xl" className="mt-8 w-full max-w-xxs" onClick={nextSlide}>
				Continue
			</Button>
			<Button
				variant="link"
				className="mt-1 w-full max-w-xxs opacity-70 hover:opacity-80"
				onClick={() => {
					analytics.track("skip-connect-mcp-onboarding")
					nextSlide()
				}}
			>
				Skip for now
			</Button>
		</div>
	)
}
